<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Approved Bills System" name="description"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">
            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">APPROVED BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                      <li class="breadcrumb-item active">Approved Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h4 class="card-title text-capitalize mb-0">
                        Approved Bills History
                      </h4>
                      <div class="d-flex align-items-center">
                        <span class="badge bg-success text-white font-size-16 px-3 py-2 me-3">
                          <i class="mdi mdi-check-circle me-1"></i>
                          {{billDetails.length}} Approved
                        </span>
                        <button @click="getBillsPaginate()" class="btn btn-primary" type="button">
                          <i class="mdi mdi-refresh me-1"></i> Refresh
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filters Section -->
                  <div class="card-header bg-white pt-0 pr-0 p-0 border-bottom">
                    <div class="p-3">
                      <div class="row g-2 mb-2">
                        <div class="col-md-3 col-sm-6">
                          <select class="form-select font-13px" v-model="subCounty" @change="getBillsPaginate()">
                            <option selected="" value="">All Sub Counties</option>
                            <option :key="index" :value="item" v-for="(item, index) in subCounties">
                              {{ item.subCountyName }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <select class="form-select font-13px" v-model="ward" @change="getBillsPaginate()">
                            <option selected="" value="">All Wards</option>
                            <option :key="index" :value="item" v-for="(item, index) in wards">
                              {{ item.wardName }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <select class="form-select font-13px" v-model="approver" @change="getBillsPaginate()">
                            <option value="">All Approvers</option>
                            <option v-for="(item, index) in approvers" :key="`approver-${index}`" :value="item.approvedBy">
                              {{item.approvedBy}} ({{item.count}})
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <input v-model="search" @input="searchBills" class="form-control font-13px"
                                 placeholder="Search bill no, customer..." type="text">
                        </div>
                      </div>

                      <div class="row g-2 align-items-center">
                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">Approved From:</label>
                          <input v-model="dateFrom" class="form-control font-13px" type="date">
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">Approved To:</label>
                          <input v-model="dateTo" class="form-control font-13px" type="date">
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">&nbsp;</label>
                          <button @click="getBillsPaginate()" class="btn btn-info w-100 font-13px">
                            <i class="mdi mdi-filter me-1"></i> Apply Filters
                          </button>
                        </div>

                        <div class="col-md-3 col-sm-6">
                          <label class="form-label mb-0 font-13px">&nbsp;</label>
                          <button v-if="getRight('ECONSTRUCTION DOWNLOAD APPROVED')" @click="downloadApprovedBills()"
                                  type="button" class="btn btn-success w-100 font-13px">
                            <i class="bx bxs-download font-size-16"></i> <span class="pl-1">Download</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table Section -->
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th class="text-nowrap" scope="col" style="width: 50px;">NO.</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Bill No</th>
                          <th class="text-nowrap" scope="col" style="min-width: 250px;">Business Details</th>
                          <th class="text-nowrap" scope="col" style="min-width: 150px;">Location</th>
                          <th class="text-nowrap text-end" scope="col" style="width: 120px;">Amount</th>
                          <th class="text-nowrap" scope="col" style="width: 120px;">Approved By</th>
                          <th class="text-nowrap" scope="col" style="width: 120px;">Approval Date</th>
                          <th class="text-nowrap text-center" scope="col" style="width: 100px;">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(item, index) in billDetails">
                          <td class="text-nowrap">{{((currentPage - 1) * pageSize) + index + 1}}</td>
                          <td class="text-nowrap">
                            <div class="fw-semibold text-success">{{item.billNo}}</div>
                            <small class="text-muted">{{item.incomeTypePrefix}}</small>
                          </td>
                          <td>
                            <div class="fw-semibold">{{item.customerName || item.description}}</div>
                            <small class="text-muted d-block">{{item.incomeTypeDescription}}</small>
                            <small class="text-muted">{{item.feeDescription}}</small>
                          </td>
                          <td>
                            <div>{{item.subCountyName}}</div>
                            <small class="text-muted">{{item.wardName}}</small>
                            <small v-if="item.zone" class="d-block text-muted">{{item.zone}}</small>
                          </td>
                          <td class="text-end">
                            <div class="fw-bold text-success">{{formatPrice(item.detailAmount)}}</div>
                          </td>
                          <td class="text-nowrap">
                            <small class="fw-semibold">{{item.approvedBy}}</small>
                          </td>
                          <td class="text-nowrap">
                            <small>{{formatDateTime(item.dateApproved)}}</small>
                          </td>
                          <td class="text-center">
                            <button @click="viewBillDetails(item)"
                                    class="btn btn-info btn-sm me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#billDetailModal"
                                    title="View Details">
                              <i class="mdi mdi-eye"></i>
                            </button>
                            <button @click="printBill(item.billNo)"
                                    class="btn btn-primary btn-sm"
                                    title="Print">
                              <i class="mdi mdi-printer"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="4" class="text-start">
                            {{billDetails.length}} Approved Bills
                          </th>
                          <td class="text-end">
                            <div class="fw-bold">Total: {{totalDetailAmount}}</div>
                          </td>
                          <th colspan="3"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center">
                        <div class="p-5 py-0 pt-3">
                          <div class="p-5">
                            <div class="spinner-border text-info m-1" role="status">
                              <span class="sr-only text-uppercase">Loading...</span>
                            </div>
                          </div>
                        </div>
                        <h4 class="text-uppercase">Loading Data</h4>
                        <p>Fetching approved bills...</p>
                      </div>

                      <!-- No Results State -->
                      <div v-if="billDetails.length<1 && loading===false" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center">
                        <div class="p-5 py-0 pt-3">
                          <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No approved bills"/>
                        </div>
                        <h4>No Approved Bills</h4>
                        <p>No bills have been approved yet or there are no bills matching your criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination Footer -->
                  <div class="card-footer bg-white">
                    <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="pr-3 pb-0 mb-0 font-13px"><span>Rows Per Page</span></span>
                        <select class="form-select w-auto font-13px" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" @click="prevPage">Previous</a>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage">Next</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div class="modal fade" id="billDetailModal" tabindex="-1" aria-labelledby="billDetailModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header bg-success">
                <div>
                  <h5 class="modal-title text-white" id="billDetailModalLabel">
                    <i class="mdi mdi-check-circle me-2"></i>Approved Bill Details
                  </h5>
                  <small class="text-white opacity-75">{{selectedBill.billNo}}</small>
                </div>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body p-4">
                <!-- Success Badge -->
                <div class="alert alert-success d-flex align-items-center mb-4" role="alert">
                  <i class="mdi mdi-check-circle font-size-20 me-3"></i>
                  <div>
                    <strong>Approved Bill</strong>
                    <p class="mb-0">This bill has been approved and is ready for printing and payment.</p>
                  </div>
                </div>

                <!-- Bill Information Grid -->
                <div class="row mb-4">
                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="mdi mdi-information me-2"></i>Bill Information
                        </h6>
                        <div class="mb-2">
                          <small class="text-muted">Bill Number:</small>
                          <div class="fw-semibold">{{selectedBill.billNo}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Customer:</small>
                          <div class="fw-semibold">{{selectedBill.customerName || selectedBill.description}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Phone:</small>
                          <div>{{maskPhoneNumber(selectedBill.customerPhoneNumber)}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Amount:</small>
                          <div class="fw-bold text-success">{{formatPrice(selectedBill.detailAmount)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card border shadow-sm h-100">
                      <div class="card-body">
                        <h6 class="card-title text-muted text-uppercase mb-3">
                          <i class="mdi mdi-check-decagram me-2"></i>Approval Information
                        </h6>
                        <div class="mb-2">
                          <small class="text-muted">Approved By:</small>
                          <div class="fw-semibold text-success">{{selectedBill.approvedBy}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Approval Date:</small>
                          <div>{{formatDateTime(selectedBill.dateApproved)}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Created By:</small>
                          <div>{{selectedBill.names}}</div>
                        </div>
                        <div class="mb-2">
                          <small class="text-muted">Date Created:</small>
                          <div>{{formatDateTime(selectedBill.dateCreated)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Location Information -->
                <div class="card border shadow-sm mb-4">
                  <div class="card-body">
                    <h6 class="card-title text-muted text-uppercase mb-3">
                      <i class="mdi mdi-map-marker me-2"></i>Location
                    </h6>
                    <div class="row">
                      <div class="col-md-4">
                        <small class="text-muted">Sub County:</small>
                        <div class="fw-semibold">{{selectedBill.subCountyName}}</div>
                      </div>
                      <div class="col-md-4">
                        <small class="text-muted">Ward:</small>
                        <div class="fw-semibold">{{selectedBill.wardName}}</div>
                      </div>
                      <div class="col-md-4" v-if="selectedBill.zone">
                        <small class="text-muted">Zone:</small>
                        <div class="fw-semibold">{{selectedBill.zone}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Service Details -->
                <div class="card border shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-muted text-uppercase mb-3">
                      <i class="mdi mdi-file-document me-2"></i>Service Details
                    </h6>
                    <div class="mb-2">
                      <small class="text-muted">Income Type:</small>
                      <div class="fw-semibold">{{selectedBill.incomeTypeDescription}}</div>
                    </div>
                    <div class="mb-2">
                      <small class="text-muted">Fee Description:</small>
                      <div>{{selectedBill.feeDescription}}</div>
                    </div>
                    <div v-if="selectedBill.description">
                      <small class="text-muted">Additional Details:</small>
                      <div>{{selectedBill.description}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer bg-light">
                <button @click="printBill(selectedBill.billNo)" class="btn btn-primary" type="button">
                  <i class="mdi mdi-printer me-1"></i> Print Bill
                </button>
                <button class="btn btn-secondary" data-bs-dismiss="modal" type="button">
                  <i class="mdi mdi-close me-1"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">
                  Developed by County
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import moment from "moment";

export default {
  name: "ApprovedBills",
  components: {NavigationBar},
  data() {
    return {
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      dateFrom: '',
      dateTo: '',
      search: '',
      approver: '',
      message: '',

      billDetails: [],
      selectedBill: {},
      approvers: [],

      subCounties: [],
      wards: [],
      subCounty: {
        subCountyID: "",
        subCountyName: ""
      },
      ward: {
        wardID: "",
        wardName: ""
      },

      summary: {
        count: 0,
        total: 0
      }
    }
  },

  watch: {
    pageSize(newPageSize) {
      this.getBillsPaginate();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    subCounty: function() {
      this.getWards();
      this.getBillsPaginate();
    },

    ward: function() {
      this.getBillsPaginate();
    },

    dateFrom: function() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    },

    dateTo: function() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    }
  },

  computed: {
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, bill) => sum + parseFloat(bill.detailAmount || 0), 0));
    }
  },

  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.getSubCounties();
    this.getApprovers();
    this.getBillsPaginate();
    this.menuAccess();
  },

  methods: {
    getRight(type) {
      return getRight(type);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Approved Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).then(() => {}).catch(() => {});
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD MMM YYYY, hh:mm A');
    },

    gotTo(route) {
      router.push(route);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }

      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    },

    searchBills() {
      // Debounce search
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getBillsPaginate();
      }, 500);
    },

    getBillsPaginate() {
      this.billDetails.splice(0);
      this.loading = true;

      const data = new FormData();
      data.append("function", "getApprovedBills");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyID", this.subCounty.subCountyID || '');
      data.append("wardID", this.ward.wardID || '');
      data.append("approver", this.approver || '');
      data.append("search", this.search || '');

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.summary.count = 0;
            this.summary.total = 0;

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails || [];
              this.summary = res.data.data.summary || {count: 0, total: 0};
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    getApprovers() {
      const data = new FormData();
      data.append("function", "getApprovers");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.approvers = res.data.data.approvers || [];
            }
          })
          .catch((e) => {
            console.error(e);
          });
    },

    viewBillDetails(bill) {
      this.selectedBill = bill;
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });

      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    downloadApprovedBills() {
      // Simple CSV download of current page
      if (!this.billDetails || this.billDetails.length === 0) {
        alert("No data to download");
        return;
      }

      let csv = 'Bill No,Customer,Income Type,Fee,Amount,Approved By,Approval Date,Sub County,Ward\n';

      this.billDetails.forEach(bill => {
        csv += `"${bill.billNo}",`;
        csv += `"${bill.customerName || bill.description}",`;
        csv += `"${bill.incomeTypeDescription}",`;
        csv += `"${bill.feeDescription}",`;
        csv += `"${bill.detailAmount}",`;
        csv += `"${bill.approvedBy}",`;
        csv += `"${bill.dateApproved}",`;
        csv += `"${bill.subCountyName}",`;
        csv += `"${bill.wardName}"\n`;
      });

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `approved_bills_${moment().format('YYYYMMDD')}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getWards() {
      this.wards = [];
      this.ward = { wardID: '', wardName: '' };

      if (!this.subCounty.subCountyID) return;

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    }
  }
}
</script>

<style scoped>
.table td, .table th {
  padding: 0.75rem;
  vertical-align: middle;
}

.font-13px {
  font-size: 13px;
}

.card {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.badge {
  font-weight: 500;
  padding: 0.35rem 0.65rem;
}

.table-hover tbody tr:hover {
  background-color: rgba(76, 175, 80, 0.1);
}

@media print {
  .modal-header,
  .modal-footer {
    display: none;
  }
}
</style>